(function($) {
  'use strict';

  function buildRadiusSlider() {
    var $select = $('#global-iid-location-search-radius');

    if (!$select.length || $select.data('ssEnhanced')) {
      return;
    }

    var values = [];

    $select.find('option').each(function() {
      values.push(parseInt($(this).val(), 10));
    });

    if (!values.length) {
      return;
    }

    var currentValue = parseInt($select.val(), 10);
    var currentIndex = Math.max(values.indexOf(currentValue), 0);
    var $form = $select.closest('form');

    var sliderHtml =
      '<div class="ss-modern-radius">' +
      '  <div class="ss-modern-radius__track-wrap">' +
      '    <input class="ss-modern-radius__range" type="range" min="0" max="' + (values.length - 1) + '" step="1" value="' + currentIndex + '">' +
      '    <div class="ss-modern-radius__bubble">' + values[currentIndex] + '</div>' +
      '  </div>' +
      '  <div class="ss-modern-radius__labels">' +
      '    <span>' + values[0] + ' km</span>' +
      '    <span>' + values[values.length - 1] + ' km</span>' +
      '  </div>' +
      '</div>';

    var $ui = $(sliderHtml);
    var $range = $ui.find('.ss-modern-radius__range');
    var $bubble = $ui.find('.ss-modern-radius__bubble');
    var bubbleWidth = 30;

    function updateBubble(index) {
      var ratio = values.length === 1 ? 0 : index / (values.length - 1);
      var left = '0px';

      $bubble.text(values[index]);

      if (index === 0) {
        left = '0px';
      } else if (index === values.length - 1) {
        left = 'calc(100% - ' + bubbleWidth + 'px)';
      } else {
        left = 'calc(' + (ratio * 100) + '% - ' + (bubbleWidth / 2) + 'px)';
      }

      $bubble.css('left', left);
    }

    updateBubble(currentIndex);

    $range.on('input', function() {
      updateBubble(parseInt(this.value, 10));
    });

    $range.on('change', function() {
      var index = parseInt(this.value, 10);

      $select.val(String(values[index]));
      $form.trigger('submit');
    });

    $select.data('ssEnhanced', true).hide().after($ui);
  }

  $(function() {
    buildRadiusSlider();

    window.setTimeout(buildRadiusSlider, 250);
    window.setTimeout(buildRadiusSlider, 1000);
  });
})(jQuery);
